import React from "react";

interface LoadingSpinnerProps {
  message?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const LoadingSpinner = ({
  message = "로딩 중...",
  size = "md",
  className = "",
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  return (
    <div
      className={`flex flex-col items-center justify-center py-12 ${className}`}
    >
      <div className="relative">
        <div
          className={`${sizeClasses[size]} rounded-full border-2 border-gray-200`}
        ></div>

        <div
          className={`absolute top-0 left-0 ${sizeClasses[size]} rounded-full border-2 border-transparent border-t-black border-r-black animate-spin`}
        ></div>
      </div>

      {message && (
        <div className="mt-6 flex items-center space-x-1">
          <span className="text-gray-600 text-sm font-medium">{message}</span>
          <div className="flex space-x-1">
            <div
              className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: "0ms" }}
            ></div>
            <div
              className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: "150ms" }}
            ></div>
            <div
              className="w-1 h-1 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: "300ms" }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
